:host {
  display: block;
}

.spw-loading {
  display: flex;
  &__spinner {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 4px solid var(--spw-color-themes-grey-grey-100);
    border-top-color: var(--spw-ds-primary);
    animation: loading 1s linear infinite;
  }
  @keyframes loading {
    to {
      transform: rotate(360deg);
    }
  }
  &__text {
    margin-left: 8px;
    color: var(--spw-color-themes-grey-grey-800);
  }
}
